import { connect } from 'react-redux'
import AccessModalHorizontal from './AccessModalHorizontal'
import setupActions from '../../dataStore/actions/setup'
import { State } from '../../dataStore/reducers/reducerType'

const mapStateToProps = (state: State, props) => ({
  ...props,
  maxPresenters: state.config.maxPresenters,
  roomname: state.config.roomname
})
const mapDispatchToProps = dispatch => ({
  setRole: role => dispatch(setupActions.setRole(role)),
  joinRoom: () => dispatch(setupActions.joinRoom())
})

export default connect(mapStateToProps, mapDispatchToProps)(AccessModalHorizontal)
